import * as SharedEnvironment from './environment.shared';

export const environment = {
    ...SharedEnvironment.environment,

    api: `https://api.beta.app.fintrax.io/`,
    production: true,
    showExperimentalFeatures: true,
    replaysSessionSampleRate: 0.1,
    sentryEnvironment: 'development',
};

SharedEnvironment.injectEndpoints(environment);
